import { FileUploader } from "react-drag-drop-files";
import { ButtonUnstyled } from "../button";
import styles from "./styles.module.scss";

interface Props {
  children: any;
  onFileChanged: (file?: File | File[]) => void;
  onClickFileInput?: (file?: File | string) => any;
  accept?: string[];
  disabled?: boolean;
  inputRef?: (ref: HTMLButtonElement) => void;
  onBlur?: (value: React.ChangeEvent<HTMLButtonElement>) => void;
}

export function FileInputAtom(props: Readonly<Props>) {
  if (props.disabled) {
    return props.children;
  }

  return (
    <div className={styles.file_input}>
      <ButtonUnstyled id={"File_input"} inputRef={props.inputRef} onBlur={props.onBlur} onClick={() => {}}>
        <FileUploader multiple={false} types={props.accept} handleChange={props.onFileChanged}>
          {props.children}
        </FileUploader>
      </ButtonUnstyled>
    </div>
  );
}
